export default {
    ABOUT_DEVICE_BTN_BACK: 'aboutMyDeviceBtnBack',
    ABOUT_MY_DEVICE_OFFLINE_NOTIFICATION: 'aboutMyDeviceOfflineNotification',
    AGE_VERIFICATION_PAGE: 'verifyAgePage',
    CAROUSEL_DOT: 'carouselItem',
    DATA_COLLECTION_PAGE: 'dataCollectionPage',
    DEVICE_LIST_BTN_ACTIVATE: 'deviceListBtnActivate',
    DEVICE_LIST_BTN_ADD_NEW: 'deviceListBtnAddNew',
    DEVICE_LIST_BTN_AVAILABLE_FWU_CLOSE_BTN: 'deviceListBtnAvailableFirmwareCloseBtn',
    DEVICE_LIST_BTN_AVAILABLE_FWU: 'deviceListBtnAvailableFirmware',
    DEVICE_LIST_BTN_LOCK: 'deviceListBtnLock',
    DEVICE_LIST_BTN_PAIR: 'deviceListBtnPairDevice',
    DEVICE_LIST_BTN_PAIRING_IFO_POPUP_PAIR_DEVICE: 'deviceListBtnPairingInfoPopupPairDevice',
    DEVICE_LIST_BTN_SET_UP_DEVICE_POPUP_BLE: 'deviceListBtnSetUpDevicePopupBle',
    DEVICE_LIST_BTN_SET_UP_DEVICE_POPUP_USB: 'deviceListBtnSetUpDevicePopupUSB',
    DEVICE_LIST_BTN_SETTINGS: 'deviceListBtnSettings',
    DEVICE_LIST_BTN_UNLOCK: 'deviceListBtnUnlock',
    DEVICE_LIST_DEVICE_CORTEZ: 'pairingSequenceBtnSelectCortez',
    DEVICE_LIST_DEVICE_MULTI: 'pairingSequenceBtnSelectMulti',
    DEVICE_LIST_DEVICE_ORIGINALS_ONE: 'pairingSequenceBtnSelectOriginalsOne',
    DEVICE_LIST_DEVICE_ORIGINALS_DUO: 'pairingSequenceBtnSelectOriginalsDuo',
    DEVICE_LIST_DEVICE_ORDINARY: 'pairingSequenceBtnSelectOrdinary',
    DEVICE_LIST_DEVICE_SOYUZ: 'pairingSequenceBtnSelectSoyuz',
    DEVICE_LIST_DEVICE_ARIANE: 'pairingSequenceBtnSelectAriane',
    DEVICE_LIST_ITEM: 'DeviceListItem',
    DEVICE_LIST_PAGE: 'deviceListPage',
    DEVICE_LOCK_BUTTON: 'DeviceLockBtn',
    FWU_ADDITIONAL_STEPS_GUIDE_BTN_BACK: 'fwuAdditionalStepsGuideBtnBack',
    LEGAL_AND_POLICY_BTN_BACK: 'legalAndPolicyBtnBack',
    LEGAL_AND_POLICY_POPUP: 'legalAndPolicyPopup',
    LEGAL_DISCLAIMER_BTN_BACKS: 'legalDisclaimerBtnBack',
    LEGAL_DISCLAIMER_BTN_CONTINUE: 'legalDisclaimerBtnContinue',
    LEGAL_DISCLAIMER_PAGE: 'legalDisclaimerPage',
    LOADER_CONTROL: 'LoaderControl',
    PAIRING_SEQUENCE_BTN_NEXT: 'pairingSequenceBtnNext',
    PAIRING_SEQUENCE_BTN_SELECT_P1V40: 'pairingSequenceBtnSelectVoyager',
    PAIRING_SEQUENCE_BTN_SELECT_P1V40D: 'pairingSequenceBtnSelectDelta',
    PAIRING_SEQUENCE_BTN_SELECT_P1V40M: 'pairingSequenceBtnSelectCosmos',
    PAIRING_SEQUENCE_BTN_SELECT_VEEV: 'pairingSequenceBtnSelectVeev',
    PAIRING_SEQUENCE_BTN_SKIP: 'pairingSequenceBtnSkip',
    PAIRING_SEQUENCE_DEVICE_SELECT_PAGE: 'pairingSequenceDeviceSelectPage',
    PAIRING_SEQUENCE_ERROR_SKIP_BTN: 'pairingSequenceErrorBtnSkip',
    PAIRING_SEQUENCE_ERROR_TRY_AGAIN_BTN: 'pairingSequenceErrorBtnTryAgain',
    PAIRING_SEQUENCE_PROGRESS_PAGE: 'pairingSequenceProgressPage',
    PAIRING_SEQUENCE_REGISTERING_PAGE: 'pairingSequenceRegisteringPage',
    PAIRING_SEQUENCE_SKIP_PAGE: 'pairingSequenceSkipPage',
    PAIRING_SEQUENCE_SUCCESSFUL_PAIRED_TITLE: 'pairingSequenceSuccessfullyPairedTextTitle',
    PAIRING_SEQUENCE_TITLE: 'pairingSequenceTitle',
    PAIRING_SKIP_POPUP_SKIP_BUTTON: 'pairingSequenceSkipBtnSkip',
    PAIRING_SKIP_POPUP_TRY_AGAIN_BUTTON: 'pairingSequenceSkipBtnTryAgain',
    PAIRING_SUCCESS_DEVICE_LIST_BUTTON: 'pairingSequenceBtnDeviceList',
    PAIRING_SUCCESS_TITLE: 'pairingSequenceTitleSuccessfullyPaired',
    POPUP_COMMON_BTN_CLOSE: 'popupBtnClose',
    PREF_CENTER_BTN_BACK: 'prefCenterBtnBack',
    PREF_CENTER_BTN_SAVE: 'prefCenterBtnSave',
    PREF_CENTER_TOGGLE_1: 'prefCenterTogle1',
    PREFERENCE_CENTER_PAGE: 'preferenceCenterPage',
    TERMS_OF_USE_PAGE: 'termOfUsePage',
    TNC_DC_AGREE: 'dataCollectionBtnAgree',
    TNC_DC_DECLINE: 'dataCollectionBtnDecline',
    TNC_DC_PREF_CENTER: 'dataCollectionBtnPrefCenter',
    TNC_TOU_BTN_AGREE: 'termOfUseBtnAgree',
    TNC_TOU_BTN_DECLINE: 'termOfUseBtnDecline',
    TNC_TOU_BTN_DETAILED: 'termOfUseBtnDetailed',
    TNC_TOU_NOTIFICATION: 'termOfUseNotification',
    VERIFY_AGE_BTN_BACK: 'verifyAgeBtnBack',
    VERIFY_AGE_BTN_CONFIRM: 'verifyAgeBtnConfirm',
    VERIFY_AGE_INPUT_DAY: 'verifyAgeInputDay',
    VERIFY_AGE_INPUT_MONTH: 'verifyAgeInputMonth',
    VERIFY_AGE_INPUT_YEAR: 'verifyAgeInputYear',
    DEVICE_LIST_DEVICE_HERMES_PRIME: 'pairingSequenceBtnSelectHermesPrime',
    DEVICE_LIST_DEVICE_HERMES_MID: 'pairingSequenceBtnSelectHermesMid',
};
